import type { AnimationProperties, AnimationsKit } from '../../../types';

const name = 'Flash';
const properties: AnimationProperties = {
  schema: {},
};

/**
 * Flash animation object
 */
function animate(
  kit: AnimationsKit,
  elements: HTMLElement[],
  duration: number,
  delay: number,
  { easing = 'cubicInOut', ...params } = {},
) {
  const sequence = kit.sequence(params);

  sequence
    .add(
      kit.animate('BaseFade', elements, duration / 2, 0, {
        to: { opacity: 0.0001 }, // opacity 0 does NOT work in repeat, tweenkit.engine bug
        ease: easing,
      }),
    )
    .add(
      kit.animate('BaseFade', elements, duration / 2, 0, {
        to: { opacity: 1 },
        ease: easing,
      }),
    )
    .add(kit.animate('BaseNone', elements, delay, 0)); // add repeat delay

  return sequence.get();
}

export { name, properties, animate };
